// extracted by mini-css-extract-plugin
module.exports = {"truncatedWrapper":"TruncatedText_truncatedWrapper__25BPt","truncatedText":"TruncatedText_truncatedText___osL5"};